export default "__VITE_ASSET__gpn3Nfgk__"